export default __webpack_public_path__ + "media/images/images/gallery/36-259f3437b9c98915c1159565038e1fc3.png";